// Version : 0.0.1
// Author : VISHAL BHARATHI
// CREATED DATA: 18-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** UPDATE TRANSFER FUNDER DETAILS START *********************** */
export const updateTransferFunderDetails = (listData: any) => {
	const data = {
		UpdateTransferFunderDetailsToken: listData,
	};
	const url = `${API_URL}updateTransferFunder`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE TRANSFER FUNDER DETAILS END *********************** */

/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP START *********************** */
export const fetchAllLoanIndexListForGroup = (listData: any) => {
	const data = {
		GetAllLoanIndexListForGroupToken: listData,
	};
	const url = `${API_URL}fetchAllLoanIndexListforGroup`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP END *********************** */
